module.exports = __webpack_public_path__ + "static/heroMobile@x2-04b6a63f24e125f1a36b63a6e6d4f07e.png";